const normalizeBase = (value) => {
    if (!value) return '';
    return value.replace(/\/+$/, '');
};

const defaultSiteUrl = 'https://code-pro.ir';
const apiBase =
    normalizeBase(process.env.REACT_APP_API_BASE_URL) || defaultSiteUrl;

export const API_BASE_URL = apiBase;
export const ADMIN_API_BASE = `${apiBase}/api/v1/admin`;
export const BLOG_API_BASE = `${apiBase}/api/v1/blog`;
export const APP_API_BASE = `${apiBase}/api/v1/app`;

const uploadsOverride = normalizeBase(
    process.env.REACT_APP_UPLOADS_BASE_URL
);
export const UPLOADS_BASE_URL =
    uploadsOverride || `${API_BASE_URL}/uploads`;

export const SITE_BASE_URL =
    normalizeBase(process.env.REACT_APP_SITE_BASE_URL) || defaultSiteUrl;
